import { useNavigate } from "react-router";
import { AppDialog } from "../../../../../common/components/AppDialog/AppDialog";
import {
  IfFalse,
  IfTrue,
  RenderWhen,
} from "../../../../../common/infrastructure/components/RenderWhen";
import { ServiceTypeListItem } from "../../../../nomenclatures/serviceType/components/ServiceTypeListItem";
import { IServiceTypeInputModel } from "../../../../nomenclatures/serviceType/models/serviceTypeInputModel";
import styles from "./EmployeeServicesDialog.module.scss";
import { routePaths } from "../../../../../common/infrastructure/routes/routePaths";

interface IEmployeeServicesDialogProps {
  visible: boolean;
  onHide: () => void;
  services?: IServiceTypeInputModel[];
  isLoading?: boolean;
  employeeName?: string;
}

export const EmployeeServicesDialog = ({
  visible,
  onHide,
  services,
  isLoading = false,
  employeeName,
}: IEmployeeServicesDialogProps) => {
  const navigate = useNavigate();

  const dialogHeader = employeeName
    ? `Услуги на ${employeeName}`
    : "Услуги на служителя";

  const onClick = () => {
    navigate(routePaths.nomenclatureServiceType);
  };

  return (
    <AppDialog
      header={dialogHeader}
      visible={visible}
      className={styles.root}
      onHide={onHide}
    >
      <div className={styles.root_content_wrapper}>
        <RenderWhen
          condition={!isLoading && (!services || services.length === 0)}
        >
          <IfTrue>
            <>Към момента този служител не извършва никакви услуги.</>
          </IfTrue>
          <IfFalse>
            {services?.map((service, i) => (
              <div
                className={styles.root_item}
                key={`${service.id}_${i}`}
                onClick={onClick}
              >
                <ServiceTypeListItem item={service} isLoading={isLoading} />
              </div>
            ))}
          </IfFalse>
        </RenderWhen>
      </div>
    </AppDialog>
  );
};
